export enum TrapType {
    outdoor = 'OUTDOOR',
    indoorFloor = 'INDOOR_FLOOR',
    indoorFlying = 'INDOOR_FLYING',
}

export interface IIndoorFloorCaptureLimit {
    trap: number,
    crawling_lower: number,
    crawling_upper: number,
    rodents_lower: number,
    rodents_upper: number,
}

export interface IIndoorAirCaptureRangeLimit {
    trap: number,
    lower: number,
    upper: number,
    acceptability_limits: string,
}

export interface ITrap {
    id: number,
    device_type: string,
    characteristic: string,
    active_substance: string,
    type: TrapType,
    capture_limit?: IIndoorAirCaptureRangeLimit | IIndoorFloorCaptureLimit,
}
